import "./ClickableTextFooter.css";

interface IClickableTextFooterProps {
    inputElementId: string;
    isFromClickableTextEditor: boolean;
}

function ClickableTextFooter(props: IClickableTextFooterProps): JSX.Element {
    function writeStringIntoControlRef(e: React.MouseEvent): void {
        let s = $(e.target).text().replace(";", "").trim();
        writeStringIntoControl(s, e.shiftKey);
    }

    function writeStringIntoControl(str: string, onNewLine: boolean): void {
        const inputReference = $(`#${props.inputElementId}`);
        let current: string = inputReference.val();

        let isEmpty = (!current || current.length === 0);
        let newValue = "";
        let parts = [];
        let cursorReturnPosition = 0;

        let p = 0;
        if (!isEmpty) {
            p = getCursorPosition(inputReference.get(0));
            parts[0] = current.substring(0, p);
            parts[1] = current.substring(p);
        }

        if (parts.length === 2) { newValue = parts[0]; }
        else { newValue = current; }

        if (!isEmpty) {
            if (newValue.charAt(newValue.length - 1) != "\s" && newValue.length > 1) {
                newValue = `${newValue} `;
            }
        }
        if (onNewLine) { newValue = `${newValue}\n`; }

        if (str === "\n" || str === "\n\n") {
            newValue = `${newValue}${str}`;
        }
        else {
            newValue = `${newValue}${str} `;
        }

        if (parts.length == 2) {
            cursorReturnPosition = newValue.length;
            newValue = `${newValue}${parts[1]}`;
        }
        else {
            cursorReturnPosition = newValue.length;
        }

        const input = document.getElementById(props.inputElementId);
        let propDescriptor: PropertyDescriptor = null;
        switch (input.nodeName) {
            case "INPUT":
                propDescriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value");
                break;
            case "TEXTAREA":
                propDescriptor = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value");
                break;
            default:
                throw new Error("The input element is not supported by ClickableTextPanel.");
        }
        propDescriptor.set.call(input, newValue);
        input.dispatchEvent(new Event("input", { bubbles: true }));

        inputReference.focus();

        if (!isEmpty) {
            setRange(inputReference.get(0), cursorReturnPosition);
        }
        else {
            setRange(inputReference.get(0), newValue.length);
        }
    }

    function getCursorPosition(elem): number {
        let d: any = document;
        let pos = 0;
        if ("selectionStart" in elem) {
            pos = elem.selectionStart;
        }
        else if ("selection" in d) {
            elem.focus();
            let Sel = d.selection.createRange();
            let SelLength = d.selection.createRange().text.length;
            Sel.moveStart("character", -elem.value.length);
            pos = Sel.text.length - SelLength;
        }
        return pos;
    }

    function setRange(element, start: number, end?: number): void {
        if (end == null) {
            end = start;
        }
        if ("selectionStart" in element) {
            element.selectionStart = start;
            element.selectionEnd = end;
        }
        else if (element.setSelectionRange) {
            element.setSelectionRange(start, end);
        }
        else if (element.createTextRange) {
            let range = element.createTextRange();
            range.collapse(true);
            range.moveEnd("character", end);
            range.moveStart("character", start);
            range.select();
        }
    }

    function insertSingleBreak(): void {
        writeStringIntoControl("\n", false);
    }

    function insertDoubleBreak(): void {
        writeStringIntoControl("\n\n", false);
    }

    return (
        <>
            <div className="b1 column">
                <button className="btn btn-primary push-right-5" onClick={() => insertSingleBreak()}><span>{"->"}</span></button>
            </div>
            <div className="b2 column">
                <button className="btn btn-primary" onClick={() => insertDoubleBreak()}><span>{"=>"}</span></button>
            </div>
            <div className="hlist column">
                <ul className="clearfix">
                    {props.isFromClickableTextEditor && (
                        <>
                            <li><a onClick={e => writeStringIntoControlRef(e)}>/*; </a></li>
                            <li><a onClick={e => writeStringIntoControlRef(e)}>*/; </a></li>
                        </>
                    )}
                    <li><a onClick={e => writeStringIntoControlRef(e)}>Ø; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&larr;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&uarr;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&rarr;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&darr;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&harr;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>↕; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>+; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>++; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>+++; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>-; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>--; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>---; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>{"<;"}</a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&le;;</a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>{">;"}</a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&ge;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&ne;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>~; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&Sigma;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>&part;; </a></li>
                    <li><a onClick={e => writeStringIntoControlRef(e)}>φ; </a></li>
                </ul>
            </div>
        </>
    );
}

export { ClickableTextFooter };
